export default __webpack_public_path__ + "static/media/employee.b367f958.png";